import { Routes, Route } from 'react-router-dom';
import ThemeProvider from './theme';
import SiteLayout from './components/layout/SiteLayout';
import ScrollToTop from './components/common/ScrollToTop';
import HomePage from './pages/home/HomePage';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import Licensing from './pages/legal/Licensing';
import Ccpp from './pages/legal/Ccpp';
import SecurityStatement from './pages/legal/SecurityStatement';
import TermsOfUse from './pages/legal/TermsOfUse';
import DataPartners from './pages/legal/DataPartners';
import OptOut from './pages/legal/OptOut';
import BusinessProfiles from './pages/legal/BusinessProfiles';
import { PATHS } from './routes';

export default function App() {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path={PATHS.home} element={<HomePage />} />
          <Route path={PATHS.privacy} element={<PrivacyPolicy />} />
          <Route path={PATHS.licensing} element={<Licensing />} />
          <Route path={PATHS.ccpp} element={<Ccpp />} />
          <Route path={PATHS.security} element={<SecurityStatement />} />
          <Route path={PATHS.terms} element={<TermsOfUse />} />
          <Route path={PATHS.dataPartners} element={<DataPartners />} />
          <Route path={PATHS.optOut} element={<OptOut />} />
          <Route path={PATHS.businessProfiles} element={<BusinessProfiles />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}
